'use client';

import { useState } from "react";
import { Menu, X } from 'lucide-react';

export default function LayoutContent({
  children
}: {
  children: React.ReactNode
}) {
  const [navbarOpen, setNavbarOpen] = useState(false);

  return (
    <>
      {children}
      <button
        onClick={() => setNavbarOpen(!navbarOpen)}
        className="text-white"
        aria-label={navbarOpen ? "Close menu" : "Open menu"}
        aria-expanded={navbarOpen}
        aria-controls="mobile-menu">
        {navbarOpen ? (
          <X className="h-6 w-6" aria-hidden="true" />
        ) : (
          <Menu className="h-6 w-6" aria-hidden="true" />
        )}
      </button>
    </>
  );
}
